import { connect, useDispatch } from 'react-redux';
import { Helmet } from "react-helmet";
import { claimFormUpdate, claimFormSecureFax, trizettoSend } from '../../../redux/actions/order/claimFormActions';
import { tabChange } from '../../../itrust_common/redux/actions/otherActions';
import { filterByKey, dateFormat } from '../../../itrust_common/components/HelperFunctions';
import OrderHeaderForm from './edit/OrderHeaderForm'
import ClaimForm from './edit/ClaimForm';
import ProcedureForm from './edit/ProcedureForm';
import ContactLensForm from './edit/ContactLensForm';
import EyeglassForm from './edit/EyeglassForm';
import MiscItemForm from './edit/MiscItemForm';
import Invoice from './edit/Invoice';
import FinalizeButtonForm from './moreActions/FinalizeButtonForm';
import PaymentsButtonForm from './moreActions/PaymentsButtonForm';
import RefundsButtonForm from './moreActions/RefundsButtonForm';
import Alert from '../../../itrust_common/components/Alert';
import ImpressionForm from './edit/ImpressionForm';
import AttachedDocsForm from './edit/AttachedDocsForm';
import { orderInvoiceEmail, orderInvoicePrint, orderUpdate } from '../../../redux/actions/order/orderActions';
import { visionInsuranceClaimFormUpdate } from '../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction';
import RpaClaimForm from '../../../containers/authorised/addOns/rpa/vision_insurance/claimForm/submitClaim/RpaClaimForm';
import { useState } from 'react';
import OrderHeader from './edit/OrderHeader';

function OrderForm(props) {
  const { activeTab, onSubmit, insuranceClaimForm, order, store, appFontSize, handleOrderEditCancel, visionInsuranceClaimForm, claimFormData, visionInsuranceConfig, services, dateFormatType, onRemoteSubmit, saving } = props;
  const [accordionToggle, setAccordionToggle] = useState(true)
  const [lastScrollPos, setLastScrollPos] = useState(0)
  const dispatch = useDispatch()

  const contactLensHoldCount = filterByKey(order.contact_lenses_attributes, 'is_on_hold', true).length
  const contactLensCount = order.contact_lenses_attributes && order.contact_lenses_attributes.length - contactLensHoldCount
  const eyeglassHoldCount = filterByKey(order.eyeglasses_attributes, 'is_on_hold', true).length
  const eyeglassCount = order.eyeglasses_attributes && order.eyeglasses_attributes.length - eyeglassHoldCount

  const handleTabChange = (data) => {
    dispatch(tabChange({ order: data }))
  }

  const handleScroll = (event) => {
    if (event.currentTarget.scrollTop === 0) {
      setLastScrollPos(event.currentTarget.scrollTop)
      setAccordionToggle(true)
    } else if (lastScrollPos < event.currentTarget.scrollTop) {
      setLastScrollPos(event.currentTarget.scrollTop)
      setAccordionToggle(false)
    }
  }

  const handleOrderSubmit = (data) => {
    dispatch(orderUpdate(data, { include: '*' }))
  }

  const handleClaimFormSubmit = (data) => {
    if (order.vision_insurance_claim_exist) {
      dispatch(visionInsuranceClaimFormUpdate(data))
    }
    else {
      dispatch(claimFormUpdate(order.id, data))
    }
  }

  const handleClaimFormSecureFax = (data) => {
    if (!order.finalized_at) {
      return Alert.warning("The order must be finalized to send the claim, please finalize the order and then submit the claim")
    }
    dispatch(claimFormSecureFax(order.id, data))
  }

  const handleEmailInvoice = () => {
    dispatch(orderInvoiceEmail(order.id))
  }

  const handlePrintInvoice = async () => {
    let res = await dispatch(orderInvoicePrint(order.id))
    window.open(res.value.data.filepath, '_blank')
  }

  const handleTrizettoSend = async () => {
    await dispatch(trizettoSend(order.id))
      .then(() => onSubmit({ id: order.id }))
  }

  const handleOnSave = () => {
    switch (activeTab) {
      case 1: onRemoteSubmit('orderProcedureForm'); break
      case 2: onRemoteSubmit('orderContactLensForm'); break
      case 3: onRemoteSubmit('orderEyeglassForm'); break
      case 4: onRemoteSubmit('orderMiscItemForm'); break
      default:
    }
  }

  const getBalanceDueBgColor = () => {
    if (order.balance_due > 0) {
      return 'bg-danger'
    }
    else if (order.balance_due < 0) {
      return 'bg-success'
    }
    else {
      return 'bg-dark'
    }
  }

  const getTotalPaidBgColor = () => {
    if (order.amount_paid > 0) {
      return 'bg-success'
    }
    else {
      return 'bg-dark'
    }
  }

  return (
    <div>
      <Helmet>
        <title>
          {`${order.patient_attributes.name} ${dateFormat(order.order_date, dateFormatType)} ${store.name}`}
        </title>
      </Helmet>
      <div className="fixed-container-modal px-5 pt-5 bg-light patient-exam-form-fixed">
        <OrderHeader
          order={order}
          activeTab={activeTab}
          claimFormData={claimFormData}
          onRemoteSubmit={onRemoteSubmit}
          accordionToggle={accordionToggle}
          handleTabChange={handleTabChange}
          setAccordionToggle={setAccordionToggle}
          handleOrderEditCancel={handleOrderEditCancel}
        />
        <OrderHeaderForm
          handleClaimProviderSubmit={handleClaimFormSubmit}
          onSubmit={onSubmit}
          defaultVisible={accordionToggle}
          activeTab={activeTab}
          claimFormData={claimFormData}
        />
        <div className="text-nowrap overflow-auto nav-tabs-view ml-0 border border-radius-6 px-3 mt-4 bg-white d-flex align-items-center justify-content-between">
          <ul className="nav nav-tabs border-0" id="myTab" role="tablist">
            <li className="nav-item" onClick={() => handleTabChange(1)}>
              <a className={`p-3 mr-3 tab-link ${activeTab === 1 && 'active'}`} href="#exam-procedures" data-toggle="tab" role="tab" aria-controls="exam-procedures" aria-selected="true">
                Exam Procedures
                {order.procedures_attributes && order.procedures_attributes.length > 0 &&
                  <span className="badge badge-info badge-pill mx-4"> {order.procedures_attributes.length} </span>
                }
              </a>
            </li>
            <li className="nav-item" onClick={() => handleTabChange(2)}>
              <a className={`p-3 mr-3 tab-link  ${activeTab === 2 && 'active'}`} href="#contact-lens-order" data-toggle="tab" role="tab" aria-controls="contact-lens-order" aria-selected="false">
                Contact Lens Orders
                {contactLensCount > 0 &&
                  <span className="badge badge-info badge-pill ml-4 mr-2"> {contactLensCount} </span>
                }
                {contactLensHoldCount > 0 &&
                  <span className="badge badge-warning badge-pill mx-4"> {contactLensHoldCount} </span>
                }
              </a>
            </li>
            <li className="nav-item" onClick={() => handleTabChange(3)}>
              <a className={`p-3 mr-3 tab-link  ${activeTab === 3 && 'active'}`} href="#eyeglass-order" data-toggle="tab" role="tab" aria-controls="eyeglass-order" aria-selected="false">
                Eyeglass Order
                {eyeglassCount > 0 &&
                  <span className="badge badge-info badge-pill ml-4 mr-2"> {eyeglassCount} </span>
                }
                {eyeglassHoldCount > 0 &&
                  <span className="badge badge-warning badge-pill mx-4"> {eyeglassHoldCount} </span>
                }
              </a>
            </li>
            <li className="nav-item" onClick={() => handleTabChange(4)}>
              <a className={`p-3 mr-3 tab-link  ${activeTab === 4 && 'active'}`} href="#misc-item" data-toggle="tab" role="tab" aria-controls="misc-item" aria-selected="false">
                Misc. Item
                {order.misc_items_attributes && order.misc_items_attributes.length > 0 &&
                  <span className="badge badge-info badge-pill mx-4"> {order.misc_items_attributes.length} </span>
                }
              </a>
            </li>
            <li className="nav-item" onClick={() => handleTabChange(5)}>
              <a className={`p-3 mr-3 tab-link ${activeTab === 5 && 'active'}`} href="#invoice" data-toggle="tab" role="tab" aria-controls="invoice" aria-selected="false">
                Order Summary
              </a>
            </li>
            {(insuranceClaimForm.id || visionInsuranceClaimForm.id) &&
              <li className="nav-item" onClick={() => handleTabChange(6)}>
                <a className={`p-3 mr-3 tab-link ${activeTab === 6 && 'active'}`} href="#claim-1500" data-toggle="tab" role="tab" aria-controls="claim-1500" aria-selected="false">
                  Claim Form
                </a>
              </li>
            }
            <li className="nav-item" onClick={() => handleTabChange(7)}>
              <a className={`p-3 mr-3 tab-link ${activeTab === 7 && 'active'}`} href="#attachedDocs" data-toggle="tab" role="tab" aria-controls="attachedDocs" aria-selected="false">
                Attached Docs
                {order.patient_documents_attributes?.length > 0 &&
                  <span className="badge badge-info badge-pill mx-4">{order.patient_documents_attributes.length}</span>
                }
              </a>
            </li>
          </ul>
          <div className="d-flex">
            <span>Indicator</span>
            <span className="badge badge-info badge-pill mx-5"> Total Count </span>
            <span className="badge badge-warning badge-pill"> Item On Hold </span>
          </div>
        </div>
      </div>
      <div id="orderForm-scroll" className={`${accordionToggle ? 'middle-container-modal-2' : 'middle-container-modal'} px-5 mb-9 ${saving && 'disabled'}`}>
        <div className="tab-content overflow-auto overflow-x-hidden mt-lg-0 mt-6 order-form-header" onScroll={handleScroll}
          style={{ height: '750px' }}>
          {activeTab === 1 &&
            <div className={`${order.status === 'finalized' && 'disabled'} ${insuranceClaimForm && insuranceClaimForm.id && `${appFontSize == "large" ? 'pt-10' : 'pt-8'}`} tab-pane active`} id="exam-procedures" role="tabpanel" aria-labelledby="exam-procedures-tab">
              <ProcedureForm onSubmit={onSubmit} />
              <ImpressionForm onSubmit={onSubmit} />
            </div>
          }
          {activeTab === 2 &&
            <div className={`${insuranceClaimForm && insuranceClaimForm.id && `${appFontSize == "large" ? 'pt-10' : 'pt-8'}`} tab-pane active`} id="contact-lens-order" role="tabpanel" aria-labelledby="contact-lens-order-tab">
              <ContactLensForm onSubmit={onSubmit} onRemoteSubmit={onRemoteSubmit} />
            </div>
          }
          {activeTab === 3 &&
            <div className={`${insuranceClaimForm && insuranceClaimForm.id && `${appFontSize == "large" ? 'pt-10' : 'pt-8'}`} tab-pane active`} id="eyeglass-order" role="tabpanel" aria-labelledby="eyeglass-order-tab">
              <EyeglassForm onSubmit={onSubmit} onRemoteSubmit={onRemoteSubmit} />
            </div>
          }
          {activeTab === 4 &&
            <div className={`${order.status === 'finalized' && 'disabled'} ${insuranceClaimForm && insuranceClaimForm.id && `${appFontSize == "large" ? 'pt-10' : 'pt-8'}`} tab-pane active`} id="eyeglass-order" role="tabpanel" aria-labelledby="eyeglass-order-tab">
              <MiscItemForm onSubmit={onSubmit} />
            </div>
          }
          {activeTab === 5 &&
            <div className="tab-pane active" id="invoice" role="tabpanel" aria-labelledby="invoice-tab">
              <Invoice />
            </div>
          }
          {claimFormData.id && activeTab === 6 &&
            <div className={`tab-pane active ${appFontSize == "large" ? 'pt-10' : 'pt-8'}`} id="claim-1500" role="tabpanel" aria-labelledby="claim-1500-tab">
              {/* {(isRpaSupported && !insurance?.config?.form_1500) ? */}
              {(!order.vision_insurance_service?.form_1500 && order.vision_insurance_service?.insurance_payer) ?
                <RpaClaimForm /> :
                <ClaimForm
                  order={order}
                  onSubmit={handleClaimFormSubmit}
                  onSecureFax={handleClaimFormSecureFax}
                  onTrizettoSend={handleTrizettoSend}
                />
              }
            </div>
          }
          {activeTab === 7 &&
            <div className="tab-pane active" id="attached-docs" role="tabpanel" aria-labelledby="attached-docs-tab">
              <AttachedDocsForm onSubmit={handleOrderSubmit} />
            </div>
          }
        </div>
      </div>
      <PaymentsButtonForm />
      <FinalizeButtonForm />
      <RefundsButtonForm />
    </div>
  )
}

OrderForm = connect(state => {
  const { other, auth, order, claimForm: { insurance_claim_form }, visionInsuranceClaimForm: { visionInsuranceClaimForm }, organisation, currentStore, visionInsurance: { services }, setting: { orgConfig } } = state;

  return {
    appFontSize: auth.user && auth.user.font_size,
    order: order.order,
    saving: order.saving,
    orderEditing: order.editing,
    isFormChanged: order.isFormChanged,
    insuranceClaimForm: insurance_claim_form,
    claimFormData: order.order.vision_insurance_claim_exist ? visionInsuranceClaimForm : insurance_claim_form,
    visionInsuranceClaimForm,
    activeTab: other.activeTab.order,
    organisation: organisation.organisation,
    store: currentStore.store,
    visionInsuranceConfig: organisation.organisation.add_ons_config?.type?.vision_insurance,
    services,
    dateFormatType: organisation.organisation.preferences?.date_format,
  }
})(OrderForm)

export default OrderForm;